
// set global failsafe timeout ~500ms after DM UI bidder timeout
export const FAILSAFE_TIMEOUT = 5000;

export function demandManagerRequest(slotMap: any[], promiseResolveFn?: (...params: any[]) => void, isAdRefresh?: boolean) {
    if (!slotMap?.length) {
        return;
    }

    // failsafeHandler with callback function to fire when we want to make 
    // the ad server request, as well as slotMap to use in case of failsafe 
    const sendAdServerRequest = failsafeHandler((bids: any) => {
        // wait for AST to load
        window?.apntag?.anq?.push(function() {

            // define an array of AST tags to refresh
            const tagsToRefresh = [] as any[];

            // loop through slot map (not bids) in case of no bids
            slotMap.forEach((slotMapObject) => {
    
                // map the slot map object to an AST tag
                const apnTag = window.apntag.getTag(slotMapObject.name);
      
                // manage ad-server targeting key/value pairs if matched and
                // add AST tag to array of slots to refresh
                if (apnTag) {
                    window.pbjs?.setTargetingForAst(apnTag.targetId);
                    tagsToRefresh.push(apnTag.targetId);
                }
            });

            // refresh the array of AST tags
            if (tagsToRefresh.length) {
                if (isAdRefresh) {
                    window.apntag.refresh(tagsToRefresh);
                } else {
                    window.apntag.loadTags(tagsToRefresh);
                }
                setTimeout(() => {
                    // compensate for time to make /ut request.
                    promiseResolveFn?.();
                }, 100);
            }

        });
    }, slotMap);

    // request bids when PBJS is ready
    window?.pbjs?.rp?.requestBids({
        callback: sendAdServerRequest,
        slotMap: slotMap,
        divPatternMatching: true
    });

    // start the failsafe timeout
    setTimeout(sendAdServerRequest, FAILSAFE_TIMEOUT);

    // function that handles the failsafe using boolean logic per auction
    function failsafeHandler(callback: (params: any) => void, initialSlots: any) {
        let adserverRequestSent = false;
        return (bidsBackSlots: any) => {
            if (adserverRequestSent) {
                return;
            }
            adserverRequestSent = true;
            callback(bidsBackSlots || initialSlots);
        };
    }
}

export function demandManagerRequestSingleSlot(slotMap: any[]) {
    if (!slotMap?.length) {
        return;
    }
    // provide failsafeHandler with callback function to fire when we want to make 
    // the ad server request, as well as slotMap to use in case of failsafe 
    const sendAdServerRequest = failsafeHandler((bids: any) => {
        // wait for AST to load
        window?.apntag?.anq?.push(function() {

            // define an array of AST tags to refresh
            const tagsToRefresh = [] as any[];

            // loop through slot map (not bids) in case of no bids
            slotMap.forEach((slotMapObject) => {
    
                // map the slot map object to an AST tag
                const apnTag = window.apntag.getTag(slotMapObject.name);
      
                // manage ad-server targeting key/value pairs if matched and
                // add AST tag to array of slots to refresh
                if (apnTag) {
                    window.pbjs?.setTargetingForAst(apnTag.targetId);
                    tagsToRefresh.push(apnTag.targetId);
                }
            });

            // refresh the array of AST tags
            if (tagsToRefresh.length) {
                window.apntag.loadTags(tagsToRefresh[0]);
            }

        });
    }, slotMap);

    // request bids when PBJS is ready
    window?.pbjs?.rp?.requestBids({
        callback: sendAdServerRequest,
        slotMap: slotMap,
        divPatternMatching: true
    });

    // start the failsafe timeout
    setTimeout(sendAdServerRequest, FAILSAFE_TIMEOUT);

    // function that handles the failsafe using boolean logic per auction
    function failsafeHandler(callback: (params: any) => void, initialSlots: any) {
        let adserverRequestSent = false;
        return (bidsBackSlots: any) => {
            if (adserverRequestSent) {
                return;
            }
            adserverRequestSent = true;
            callback(bidsBackSlots || initialSlots);
        };
    }
}

export function demandManagerInfiniteScrollAdsRequest(slotMap: any[], infiniteScrollAdSlotDivId: string, promiseResolveFn?: (...params: any[]) => void, isAdRefresh?: boolean) {
    if (!slotMap?.length) {
        return;
    }
    // provide failsafeHandler with callback function to fire when we want to make 
    // the ad server request, as well as slotMap to use in case of failsafe 
    const sendAdServerRequest = failsafeHandler((bids: any) => {
        // wait for AST to load
        window?.apntag?.anq?.push(function() {

            // define an array of AST tags to refresh
            const tagsToRefresh = [] as any[];

            // loop through slot map (not bids) in case of no bids
            slotMap.forEach((slotMapObject) => {
    
                // map the slot map object to an AST tag
                const apnTag = window.apntag.getTag(slotMapObject.divId);
               
                // manage ad-server targeting key/value pairs if matched and
                // add AST tag to array of slots to refresh
                if (apnTag) {
                    window.pbjs?.setTargetingForAst(apnTag.targetId);
                    tagsToRefresh.push(apnTag.targetId);
                }
            });

            // refresh the array of AST tags
            if (tagsToRefresh.length) {
                if (isAdRefresh) {
                    window.apntag.refresh(tagsToRefresh);
                } else {
                    window.apntag.loadTags(tagsToRefresh);
                }
                setTimeout(() => {
                    // compensate for /ut requests in flight before resolving
                    promiseResolveFn?.();
                }, 100);
            }

        });
    }, slotMap);

    // request bids when PBJS is ready
    window?.pbjs?.rp?.requestBids({
        callback: sendAdServerRequest,
        slotMap: slotMap,
        divPatternMatching: false
    });

    // start the failsafe timeout
    setTimeout(sendAdServerRequest, FAILSAFE_TIMEOUT);

    // function that handles the failsafe using boolean logic per auction
    function failsafeHandler(callback: (params: any) => void, initialSlots: any) {
        let adserverRequestSent = false;
        return (bidsBackSlots: any) => {
            if (adserverRequestSent) {
                return;
            }
            adserverRequestSent = true;
            callback(bidsBackSlots || initialSlots);
        };
    }
}